import { render, staticRenderFns } from "./AdminShipperPriceEditModal.vue?vue&type=template&id=77dd7852"
import script from "./AdminShipperPriceEditModal.vue?vue&type=script&lang=js"
export * from "./AdminShipperPriceEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77dd7852')) {
      api.createRecord('77dd7852', component.options)
    } else {
      api.reload('77dd7852', component.options)
    }
    module.hot.accept("./AdminShipperPriceEditModal.vue?vue&type=template&id=77dd7852", function () {
      api.rerender('77dd7852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminShipperPriceEditModal.vue"
export default component.exports